import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, switchMap, map } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

/**
 * Auth guard service.
 *
 * If user is authenticated, redirect the user to Dashboard or Overview page depending on status.
 * If user is not authenticated, redirect the user to Login page
 */
@Injectable()
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isDoneLoading$.pipe(
      filter((isDone) => isDone),
      switchMap((_) => this.authService.isAuthenticated$),
      map((isAuthenticated) => {
        if (isAuthenticated) {
          /**
           * If user is authenticated, send user to Dashboard or Overview page.
           */
          const driverID = this.authService.driverID;
          const driverStatus = this.authService.driverStatus;

          console.log('driverID', driverID);
          console.log('driverStatus', driverStatus);

          if (this.authService.isValidUser()) {
            /**
             * If user has driverID and status is 'Y' or 'A' or 'P' (Active or Pending), the user is a valid user.
             * When he tries to access onboarding or login routes, redirect the user to Dashboard page.
             * He cannot access onboarding routes.
             */
            if (
              route.routeConfig.data?.onboarding ||
              route.routeConfig.data?.login
            ) {
              this.router.navigateByUrl('/dashboard');
            }
          } else if (this.authService.isNewOrPendingUser()) {
            /**
             * If the user doesn't have driverID,
             * the user hasn't submitted application forms yet.
             *
             * If this user tries to access Dashboard, redirect the user to Overview page.
             */
            if (
              route.routeConfig.data?.onboarding === false ||
              route.routeConfig.data?.login
            ) {
              this.router.navigateByUrl('/overview');
            }
          } else {
            /**
             * This is invalid status and never occur.
             * Log out user.
             */
            this.authService.revokeTokenAndLogout();
            return false;
          }
        } else {
          /**
           * User is not authenticated. Send him to Login form.
           */
          this.authService.login(state.url);
        }

        return isAuthenticated;
      })
    );
  }
}
